import { Component, ElementRef, Input, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalDialogComponent implements OnInit {
  constructor(private element: ElementRef) {}

  @Input() dialogTemplate: TemplateRef<null>

  displayed = false
  public error: string = null
  public loading = false

  ngOnInit() {}

  open(): void {
    this.loading = false
    this.error = null
    this.displayed = true
  }

  close() {
    this.error = null
    this.loading = false
    this.displayed = false
  }

  get isOpen() {
    return this.displayed
  }
}
